<app-login-process
  [currentStep]="currentStep"
  [registrationEmail]="email"
  [applicationType]="applicationType"
></app-login-process>
